import request from '@/utils/request'
export default {
  //新增修改团队信息
  addEditStar(method, data) {
    return request({
      url: 'teaminfo/info',
      method,
      data
    })
  },
  // 查询团队信息列表
  getStarList() {
    return request({
      url: 'teaminfo/info/list',
      method: 'get',
    })
  },
  //查看删除团队
  getDelStar(method,id) {
    return request({
      url: `teaminfo/info/${id}`,
      method
    })
  },

  // 导出星球
  exportStar() {
    return process.env.VUE_APP_BASE_API + '/teaminfo/info/export'
  },

  // 查询部门列表
  getDepartmentlist() {
    return request({
      url: 'teaminfo/info/department',
      method: 'get',
    })
  },
  // 查询奖项信息
  getAwardList() {
    return request({
      url: 'teaminfo/info/award',
      method: 'get',
    })
  },

  // 查询所有用户列表
  getUserList(pageNum, pageSize) {
    return request({
      url: `teaminfo/info/user/list?pageNum=${pageNum}&pageSize=${pageSize}`,
      method: 'post',
    })
  },
  // 查询该用户下的星球
  getUserStarList(rtx) {
    return request({
      url: `teaminfo/info/user/project/${rtx}`,
      method: 'get',
    })
  },
}